import { z } from 'zod';
import { baseEmailDTOSchema } from './base-email-dto';

export const decommissionEmailSchemas = [
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('org_decommission_warning'),
    data: z.object({
      organizationDisplayName: z.string().min(1),
      daysRemaining: z.number().positive(),
      backupRetentionDays: z.number().positive(),
      requestedBy: z.string().min(1).optional(),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('org_decommission_confirmed'),
    data: z.object({
      organizationDisplayName: z.string().min(1),
    }),
  }),
  z.object({
    ...baseEmailDTOSchema.shape,
    template: z.literal('org_decommission_cancelled'),
    data: z.object({
      organizationDisplayName: z.string().min(1),
      requestedBy: z.string().min(1).optional(),
    }),
  }),
] as const;
